import {useMutation} from '@tanstack/react-query';
import {showHttpErrorToast} from '@common/http/show-http-error-toast';
import {apiClient} from '@common/http/query-client';

export function useSendPhoneUpdateOtp() {
  return useMutation({
    mutationFn: () => sendOtp(),
    onError: err => showHttpErrorToast(err),
  });
}

function sendOtp() {
  return apiClient
    .post('phone-update/send-otp')
    .then(response => response.data);
}
